import generatePicker from 'antd/es/date-picker/generatePicker';
import momentGenerateConfig from '@rc-component/picker/generate/moment';
import AntDatePicker, { DatePickerGlobalStyles } from './styles/datePicker.style';

const MomentDatePicker = generatePicker(momentGenerateConfig);

const Datepicker = AntDatePicker(MomentDatePicker);
const DateRangepicker = AntDatePicker(MomentDatePicker.RangePicker);

const DatepickerWithGlobalStyles = (props) => (
  <>
    <DatePickerGlobalStyles />
    <Datepicker {...props} />
  </>
);

const DateRangepickerWithGlobalStyles = (props) => (
  <>
    <DatePickerGlobalStyles />
    <DateRangepicker {...props} />
  </>
);

export default DatepickerWithGlobalStyles;
export { Datepicker, DateRangepicker, DateRangepickerWithGlobalStyles };
